import { ContactUs, ContactUsResponse } from '@core/models/contact.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ContactService {
    private readonly getAllContactsURL = `/contact/getAll`;

    getAllContacts(pageNumber: number, pageSize: number) {
        return fetchWithRetry(
            API.get<ContactUsResponse>(this.getAllContactsURL, {
                params: { pageNumber, pageSize },
            })
        );
    }
}

export default new ContactService();

